(() => {
  if (customElements.get('sac-hero-video')) return;

  let autoplayAttempted = false;

  class SacHeroVideo extends HTMLElement {
    connectedCallback() {
      if (this.listeners) return;
      this.video = this.querySelector('video');
      this.playButton = this.querySelector('[data-video-play]');
      this.status = this.querySelector('[data-video-status]');
      if (!this.video || !this.playButton) return;

      this.listeners = new AbortController();
      const options = { signal: this.listeners.signal };
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.connection = navigator.connection;
      this.visible = false;
      this.allowAuto = !this.motion.matches && !this.connection?.saveData;

      if (!this.sourceSelected) {
        const phone = window.matchMedia('(max-width: 749px)').matches;
        const source = phone ? this.dataset.phoneSrc : this.dataset.desktopSrc;
        if (source && source !== this.video.getAttribute('src')) {
          this.video.src = source;
          this.video.load();
        }
        this.sourceSelected = true;
      }

      this.setAttribute('data-enhanced', 'true');
      this.playButton.addEventListener('click', () => this.play(true), options);
      this.video.addEventListener('playing', () => {
        autoplayAttempted = true;
        this.setAttribute('data-playing', 'true');
        if (this.status) this.status.hidden = true;
      }, options);
      this.video.addEventListener('error', () => {
        this.removeAttribute('data-playing');
        if (this.status) this.status.hidden = false;
      }, options);

      this.preferenceChange = () => {
        if (this.motion.matches || this.connection?.saveData) {
          this.allowAuto = false;
          this.video.pause();
        }
      };
      this.motion.addEventListener('change', this.preferenceChange, options);
      this.connection?.addEventListener('change', this.preferenceChange, options);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.video.pause();
        else this.tryAutoplay();
      }, options);

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver((entries) => {
          const entry = entries.find((item) => item.target === this);
          if (!entry) return;
          this.visible = entry.isIntersecting && entry.intersectionRatio >= 0.25;
          if (!this.visible) this.video.pause();
          else this.tryAutoplay();
        }, { threshold: [0, 0.25] });
        this.observer.observe(this);
      }
    }

    tryAutoplay() {
      if (!this.allowAuto || autoplayAttempted || !this.visible || document.hidden) return;
      autoplayAttempted = true;
      this.play(false);
    }

    play(manual) {
      if (manual) autoplayAttempted = true;
      this.video.muted = true;
      if (this.video.error && manual) this.video.load();
      const pending = this.video.play();
      if (pending && typeof pending.catch === 'function') {
        pending.catch(() => {
          if (this.video.paused) this.removeAttribute('data-playing');
        });
      }
    }

    disconnectedCallback() {
      this.listeners?.abort();
      this.listeners = null;
      this.observer?.disconnect();
      this.observer = null;
      this.video?.pause();
    }
  }

  customElements.define('sac-hero-video', SacHeroVideo);
})();
